
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2cea8870!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RouterViewComponent.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RouterViewComponent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2cea8870!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RouterViewComponent.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/grid/RouterViewComponent.vue
// module id = 234
// module chunks = 2